import type { SectionCtaAttrs, SectionCtaVariant } from './sectionCta.types';
import { parseDataAttrs } from '@/shared/helpers/parseDataAttrs';

/** Map legacy variant values to current ones */
const VARIANT_MIGRATION: Record<string, SectionCtaVariant> = {
  default: 'centered',
  withImage: 'left',
  split: 'left',
};

const migrateVariant = (raw: string): SectionCtaVariant =>
  VARIANT_MIGRATION[raw] ?? (raw as SectionCtaVariant) ?? 'centered';

export const parseSectionCtaProps = (properties: Record<string, any>): SectionCtaAttrs => ({
  ...parseDataAttrs<SectionCtaAttrs>(properties, {
    icon: '',
    iconTheme: 'fad',
    heading: '',
    subheading: '',
    background: 'gradient',
    imageUrl: '',
    imageAlt: 'cta',
    imageWidth: 0,
    primaryTitle: '',
    primaryHref: '',
    primaryIcon: '',
    primaryIconTheme: 'fad',
    primaryIconPosition: 'prefix',
    secondaryEnabled: false,
    secondaryTitle: '',
    secondaryHref: '',
    secondaryIcon: '',
    secondaryIconTheme: 'fad',
    secondaryIconPosition: 'prefix',
  }),
  variant: migrateVariant(properties.dataVariant),
  mediaType: properties.dataMediaType ?? (properties.dataImageUrl ? 'image' : 'icon'),
});
